import React from "react";
import { Card, ListGroup } from "react-bootstrap";
import { INoticeDetails } from "../../../models/interfaces/INotice";
import InfoCard from "../../../components/forms/InfoCard";
//Styles:

interface IProps {
    NoticeResult: INoticeDetails;
}

//const circleStyle = {
  //width: '20px',
  //height: '20px',
  // backgroundColor: 'white',
  // border: '2px solid var(--bs-secondary-color) !important',
  // borderRadius: '50%',
  // display: 'flex',
  // justifyContent: 'center',
  // alignItems: 'center',
  // color: 'var(--bs-secondary-color) !important',
  // fontSize: '15px',
  // fontWeight: 'bold',
  // fontFamily: 'Arial, sans-serif',
 // marginLeft: '2px', // Espace entre le texte et le cercle
  //};
  const itemStyle = {
    display: 'flex',
    alignItems: 'center',
    border: 'none',
    padding: 0,
    marginRight: '10px'
  };

const Bloc1: React.FC<IProps> = ({
  NoticeResult
}) => {
  return (
    <Card>
    <Card.Body>
      <Card.Title style={{ textAlign: 'left' }}>{NoticeResult?.Titre}</Card.Title>
      <ListGroup horizontal>
          {NoticeResult?.Auteurs?.map((item, index) => (
            <ListGroup.Item className="mb-2 text-muted card-subtitle h6" key={index} style={itemStyle}>
              {item.formebib}
              {item.idBnf !== null && item.idBnf !== '' && (
                <>
             
             <InfoCard
             content={"Autorité BNF"}
             popICon={<svg width="20"
              height="20"
              version="1.1"
              viewBox="0 0 240 240"
              xmlns="http://www.w3.org/2000/svg">
               <path d="M119.88,29.76a90.12,90.12,0,1,1-90.12,90.12,90.23,90.23,0,0,1,90.12-90.12m0-10A100.12,100.12,0,1,0,220,119.88,100.13,100.13,0,0,0,119.88,19.76ZM154.38,170l10.55,0L126.55,55.08h-14L74.72,170H85.25l10-30.51h48.9ZM98.6,129.5l21-63.72,21.28,63.72Z"/>
             </svg>}
             /></>
              )}
            </ListGroup.Item>


          ))}
          {/* <ListGroup.Item className="mb-2 text-muted card-subtitle h6" style={itemStyle}>
          hello
          <span style={circleStyle}>A</span>
          </ListGroup.Item> */}
        </ListGroup>
    </Card.Body>
  </Card>
  );
};

export default Bloc1;
